// regularBroadcastingAuth.js
import api from "../api/axios-api";

export async function authorizeRegularBroadcasting(socketId, channel, callback) {
    const channelNameParts = channel.name.split('.');
    const quizId = channelNameParts[1];
    const participantId = channelNameParts[3];

    try {
        const response = await api.post('/quiz-participant-broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
            quiz_id: quizId,
            participant_id: participantId
        });
        callback(false, response.data);
    } catch (error) {
        callback(true, error);
    }
}
